<template>
  <DBox
    :id="'cmp-distributio-account-ssetup-manual_matches'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('discount')}`"
    @addClick="onAddClick"
  >
    <NTable
      class="dbox1"
      id="distributio-account-ssetup-manual_matches"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('discount')">
            <Dropdown2
           
              id="price_code_id"
              :label="$dft.capHead($t('price_code_id'))"
              :placeholder="'Select ' + $dft.capHead($t('price_code'))"
              :disabled="false"
              :options="priceCodeTV||[]"
              :selected="priceCodeTV.find(
                  (e) => e.value == item.price_code_id
              )"
              :showLabel="false"
              @selectedChange="(e) => onDropdownChange('price_code_id', e,item)"
              :bb="'none'"
            />
            <!-- <span class="txtov">{{ item["text02"] }}</span> -->
          </td>
          <td v-bind="tdcon('percent')">
            <TextField2
              style="flex:1"
              id="discount"
              :placeholder="$dft.capHead($t('discount'))"
              :showLabel="false"
              :value="item.discount"
              @blur="(e) => onTextFieldValueChange(e,item)"
               :bb="'none'"
            />
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                @click.stop="e => deleteItem(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { createTV } from '../../../../models/text-value.model';

export default {
  props: {
    selectedAccountsDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("discount"), 
        createTableHeader("percent"), 
        createTableHeader("options", { text: false, mw: 30 }), 
      ];
    },
    priceCodeTV:function(){
      
      return createTV(this.selectedAccountsDetails.price_codes,'price_code_name','price_code_id') || [];
    },
    list: function() {
      return this.selectedAccountsDetails.account_pricecodes || [];
    }
  },

  methods: {
    onTextFieldValueChange:function({name,value},item){
      console.log({name,value},item)

      const { account_pricecode_id } =item

      this.$emit('change',{name,value , kVal:account_pricecode_id ,key:'account_pricecode_id'})
    },
    onDropdownChange:function(name,value,item){
      console.log(name,value.value,item)
      const { account_pricecode_id } =item

      this.$emit('change',{name,value:value.value ,kVal:account_pricecode_id ,key:'account_pricecode_id'})
    },
    deleteItem:function(item){
      console.log(item,"::::::::::::::")
      this.$emit('delete',item)
    },
    onAddClick: function () {
      this.$emit("insert",);
    },
  }
};
</script>
